import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import {
  ActionSheetController,
  AlertController,
  NavParams,
  LoadingController,
  ToastController,
  ModalController,
} from '@ionic/angular';

import { Discount } from '../../../../../models';
import { StylistService } from '../../../../../services/stylist.service';
import { Utilities } from '../../../../../utilities/utilities';

@Component({
  selector: 'app-stylist-discount-form',
  templateUrl: './stylist-discount-form.component.html',
  styleUrls: ['./stylist-discount-form.component.scss'],
})
export class StylistDiscountFormComponent implements OnInit {

  public discount: Discount;

  public name: UntypedFormControl;

  public type;

  public amount: UntypedFormControl;

  public discountCommission: UntypedFormControl;

  public discountForm: UntypedFormGroup;

  public submitted: boolean;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private stylistService: StylistService,
    private formBuilder: UntypedFormBuilder,
    private alertController: AlertController,
    private loadingCtrl: LoadingController,
    private toastController: ToastController,
    private actionSheetCtrl: ActionSheetController
  ) {
    this.discount = this.navParams.get('discount');
    this.name = new UntypedFormControl(this.discount.name, [
      Validators.required,
      Validators.maxLength(25),
    ]);
    this.type = this.discount.type+"";
    this.amount = new UntypedFormControl(this.discount.amount, [Validators.required]);
    this.discountCommission = new UntypedFormControl(
      this.discount.discountCommission === 1,
      [Validators.required]
    );
    this.discountForm = this.formBuilder.group({
      name: this.name,
      amount: this.amount,
      discountCommission: this.discountCommission,
    });
  }

  public ngOnInit() {}

  public dismiss() {
    this.modalCtrl.dismiss();
  }

  public async save() {
    this.submitted = true;

    if (!this.discountForm.valid) {
      return;
    }

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    this.discount = this.discount.setName(this.name.value);
    this.discount = this.discount.setType(parseInt(this.type, 10));
    this.discount = this.discount.setAmount(
      Utilities.roundTo2Decimal(this.amount.value)
    );
    this.discount = this.discount.setDiscountCommission(
      this.discountCommission.value ? 1 : 0
    );

    this.stylistService.saveStylistDiscount(this.discount).subscribe({
      next: (discount: Discount) => {
        this.discount = discount;
        loader.dismiss().then(() => {
          const data = {
            action: 'save',
            discount: this.discount,
          };
          this.modalCtrl.dismiss(data).then(async () => {
            const toast = await this.toastController.create({
              message: `Discount has been updated`,
              duration: 3000,
            });
            toast.present();
          });
        });
      },
      error: (err) => {
        loader.dismiss().then(async () => {
          const alert = await this.alertController.create(
            Utilities.getDefaultErrorMessageConfig()
          );
          alert.present();
        });
      },
    });
  }

  public async delete() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Are you sure you want to delete this discount?',
      buttons: [
        {
          text: `Yes, delete this discount`,
          icon: 'trash',
          role: 'destructive',
          cssClass: 'sm-error',
          handler: () => {
            actionSheet.dismiss().then(async () => {
              const loader = await this.loadingCtrl.create({
                spinner: 'crescent',
              });
              loader.present();

              this.stylistService.deleteStylistDiscounts(this.discount).subscribe({
                next: (success) => {
                  loader.dismiss().then(() => {
                    const data = {
                      action: 'delete',
                      discount: this.discount,
                    };

                    this.modalCtrl.dismiss(data).then(async () => {
                      const toast = await this.toastController.create({
                        message: `Discount has been deleted`,
                        duration: 3000,
                      });
                      toast.present();
                    });
                  });
                },
                error: (err) => {
                  loader.dismiss().then(async () => {
                    const alert = await this.alertController.create(
                      Utilities.getDefaultErrorMessageConfig()
                    );
                    alert.present();
                  });
                },
              });
            });

            return false;
          },
        },
        {
          text: 'Cancel',
          role: 'cancel',
          icon: 'close',
          handler: () => {
            actionSheet.dismiss();
            return false;
          },
        },
      ],
    });

    actionSheet.present();
  }

}
